import styles from "./ElementTooltipLabelSingle.module.scss";

function ElementTooltipLabelSingle({ label }) {
  return <div className={styles["tooltip__label"]}>{label}</div>;
}

export default ElementTooltipLabelSingle;
